var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-select" },
    [
      _c("c-input", {
        attrs: {
          label: "Тип таблицы",
          placeholder: "Выберите тип таблицы",
          type: "select",
          items: _vm.tables,
          searchable: true,
          required: _vm.error,
          "required-message": _vm.error,
          "required-condition": _vm.error,
        },
        model: {
          value: _vm.localValue,
          callback: function ($$v) {
            _vm.localValue = $$v
          },
          expression: "localValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }